<template>
    <div class="applanding-ts testimonial-slider-area section-space--pt_120" id="testimonial">
        <div class="testimonial-slider-area section-space--pb_90">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="testimonial-slider border-bottom-drak  section-space--pb_90">
                            <div class="swiper-container testimonial-slider__container">
                                <div class="swiper-wrapper testimonial-slider__wrapper">
                                    <swiper 
                                        :speed="1000"
                                        :loop="true"
                                    >
                                        <swiper-slide class="wow move-up">
                                            <div class="app-landing-testimonial-slider__wrap">
                                                <div class="post-thumbnail">
                                                    <img src="../assets/img/team/avatar-01-140x140.png" class="img-fluid" alt="">
                                                </div>
                                                <div class="testimonial-slider--info">
                                                    <div class="testimonial-slider__text">"Luszol's energy and machine systems have helped mantain our medical imaging centre working in optimal conditions even with a unreliable local power grid."</div>
                                                    <div class="testimonial-slider__author">
                                                        <h6 class="name">Juan Carlos Hernandez</h6>
                                                        <span class="designation">Manager at Diagnosticos Medicos de Guatemala</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </swiper-slide>
                                        <swiper-slide class="wow move-up">
                                            <div class="app-landing-testimonial-slider__wrap">
                                                <div class="post-thumbnail">
                                                    <img src="../assets/img/team/avatar-02-140x140.png" class="img-fluid" alt="">
                                                </div>
                                                <div class="testimonial-slider--info">
                                                    <div class="testimonial-slider__text">"These energy backup solutions have allowed us to keep working over power outages and given us an edge over other car mechanic shops."</div>
                                                    <div class="testimonial-slider__author">
                                                        <h6 class="name">Mario Alvarez</h6>
                                                        <span class="designation">Manager at Serviteca</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </swiper-slide>
                                        <swiper-slide class="wow move-up">
                                            <div class="app-landing-testimonial-slider__wrap">
                                                <div class="post-thumbnail">
                                                    <img src="../assets/img/team/avatar-03-140x140.png" class="img-fluid" alt="">
                                                </div>
                                                <div class="testimonial-slider--info">
                                                    <div class="testimonial-slider__text">"The systems provided by Luszol has kept our hospital running through storms and unreliable power grids, thus saving lives while also lowering our monthly electric bills."</div>
                                                    <div class="testimonial-slider__author">
                                                        <h6 class="name">Dr. Rodolfo Gonzalez</h6>
                                                        <span class="designation">Medical Director at Hospital Privado de Peten</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </swiper-slide>
                                    </swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide } from "swiper/vue"
    export default {
        components: {
            Swiper,
            SwiperSlide
        },  
    }
</script>
